import { useTranslations } from 'next-intl';

interface INavLink {
  href: string;
  label: string;
}

interface INavLinks {
  left: INavLink[];
  right: INavLink[];
}

export function useNavLinks(): INavLinks {
  const t = useTranslations('nav.links');
  return {
    left: [
      { href: '/explore', label: t('explore') },
      { href: '/about', label: t('about') },
    ],
    right: [{ href: '/app', label: t('app') }],
  };
}
